import { useKexRouterCurrentPage } from '../../Kex/KexRouter/KexRouter';
import PageModelBase from '../Models/PageModelBase.interface';

function useCurrentPage<PageType extends PageModelBase>() {
  const currentPage = useKexRouterCurrentPage();
  return currentPage as PageType;
}

export default useCurrentPage;
